import { db } from '@/db'
import router from '@/router'
import { getAllUsersInformation } from '@/services/admin'
import { routerPush } from '@/services/routing'
import { initRequestHelper } from '@/store/root'
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex'
import { AdminState } from '../types/admin'
import { RootState } from '../types/root'

const getDefaultState = (): AdminState => {
  return {
    users: [],
    selectedUserId: '',
  }
}

const moduleState = getDefaultState()

const moduleGetters: GetterTree<AdminState, RootState> = {
  users(state) {
    return state.users
  },
  getAllUsersRequest(_state, _getters, rootState) {
    return rootState.requests.getAdminUsers
  },
  selectedUser(state) {
    return state.users.filter((u) => u.uid === state.selectedUserId)[0]
  },
}

const moduleMutations: MutationTree<AdminState> = {
  setUsers(state, users) {
    state.users = users
  },
  setSelectedUserId(state, userId) {
    state.selectedUserId = userId
  },
  resetState(state) {
    Object.assign(state, getDefaultState())
  },
}

const moduleActions: ActionTree<AdminState, RootState> = {
  async loadAllUsers({ commit }) {
    const [setSuccess, setFailure] = initRequestHelper(commit, 'getAdminUsers')
    try {
      const allUsers = await getAllUsersInformation(db)
      commit('setUsers', allUsers)
      setSuccess()
    } catch (err: any) {
      setFailure(err.message)
      throw err
    }
  },
  async goToActivity({ commit, dispatch, getters }, uid) {
    let userId = uid
    if (!uid) {
      userId = router.currentRoute.params.uid
    }
    if (!getters.users.length) {
      await dispatch('loadAllUsers')
    }
    if (getters.selectedUserId !== userId) {
      commit('setSelectedUserId', userId)
      if (router.currentRoute.params.uid !== userId) {
        routerPush(router, `/admin/activity/${userId}`)
      }
    }
  },
  async resetAdminState({ commit }) {
    commit('resetState')
  },
}

const events: Module<AdminState, RootState> = {
  namespaced: true,
  state: moduleState,
  getters: moduleGetters,
  actions: moduleActions,
  mutations: moduleMutations,
}
export default events
